import {errorHandler, getSkey, request} from './HttpClient';
import {addEventListenerIfExist, addLiveEventListener, waitForTrans} from './utils';

export default class VariantAdmin {
    constructor(app) {
        this.app = app;
        const self = this;

        // toggle *featured* state of a variant
        addEventListenerIfExist('click', e => {
            e.preventDefault();
            const btn = e.target;
            btn.loading = true;

            getSkey().then(skey => {
                request(`/vi/variant/setPartialValues/`, {
                    method: 'POST',
                    params: {
                        skey,
                        key: self.app.info.skelData.key,
                        featured: Number(!JSON.parse(btn.dataset.value)).toString(),
                    },
                })
                    .then(req => req.json())
                    .then(data => {
                        // console.log(data)
                        // console.log(data['values']['featured'])
                        btn.dataset.value = JSON.stringify(data['values']['featured']);
                        waitForTrans(() => {
                            btn.innerText = self.app.info.translations[btn.dataset.value];
                        });
                        btn.loading = false;
                    })
                    .catch(errorHandler)
            });
        }, '.js-toggle-variant-featured');

        addEventListenerIfExist('load', e => {
            console.log('handle load event for .js-hide-if-empty', this, e);
            if (parseInt(e.detail.request.headers.get('x-list-result-amount')) === 0) {
                e.target.parentNode.hidden = true;
            }
        }, '.js-hide-if-empty');

        addEventListenerIfExist('load', e => {
            console.log('handle load event for .js-show-if-not-empty', this, e);
            if (parseInt(e.detail.request.headers.get('x-list-result-amount')) > 0) {
                e.target.parentNode.hidden = false;
            }
        }, '.js-show-if-not-empty');
    }
}

